
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import FileConfig from "../FileConfig";

@Component({})
export default class CustomFileInput extends Vue {
  @Prop({ default: "El archivo es requerido." }) requiredMessage: string;
  @Prop({ default: "" }) serverValidationMessage: string;
  @Prop({ default: false }) isRequired: boolean;
  @Prop({ default: false }) allowMultiple: boolean;
  @Prop({ default: false }) disabled: boolean;
  @Prop({ default: false }) triggerInputValidations: boolean;
  @Prop({ default: new FileConfig() }) fileConfig: FileConfig;
  //
  public files: Array<File> = [];
  public showFileRequiredError: boolean = false;
  public showInvalidFileTypeError: boolean = false;
  public showInvalidFileSizeError: boolean = false;
  public inputIsValid = true;

  get inputIsEmpty() {
    return this.files.length === 0;
  }

  public onAddOrRemoveFile(): void {
    const pond: any = this.$refs.pond;
    this.files = pond.getFiles().map((x) => x.file);
    this.$emit("filesAddedOrRemoved", this.files);
    this.triggerValidations();
  }

  public runValidations(): boolean {
    if (this.isRequired && this.inputIsEmpty) {
      this.showFileRequiredError = true;
      //Set others Validations message to false
      this.showInvalidFileTypeError = false;
      this.showInvalidFileSizeError = false;
      return !this.inputIsEmpty;
    }
    const anyFileTypeInvalid: boolean = this.files.some(
      (x) => !this.fileConfig.allowedFileTypes.includes(x.type)
    );
    if (anyFileTypeInvalid) {
      this.showInvalidFileTypeError = anyFileTypeInvalid;
      //Set others Validations message to false
      this.showInvalidFileSizeError = false;
      return !anyFileTypeInvalid;
    }
    //
     const anyFileExtensionInvalid: boolean = this.files.some(
      (x) =>   this.fileConfig.notAllowExtensions.some(substring=>x.name.includes(substring))
    );
    
    if (anyFileExtensionInvalid) {
      this.showInvalidFileTypeError = anyFileExtensionInvalid;
      //Set others Validations message to false
      this.showInvalidFileSizeError = false;
      return !anyFileExtensionInvalid;
    }
    const anyFileSizeInvalid: boolean = this.files.some(
      (x) => x.size / 1000000 > this.fileConfig.fileSizeMbLimit
    );
    if (anyFileSizeInvalid) {
      this.showInvalidFileSizeError = anyFileSizeInvalid;
      return !anyFileSizeInvalid;
    }

    return true;
  }

  @Watch("triggerInputValidations")
  public triggerValidations() {
    this.inputIsValid = this.runValidations();
    this.$emit("inputValidationChanged", this.inputIsValid);
  }
}
